import React from 'react';
import { radii } from '../../theme';

const tones = {
  indigo: 'bg-bg-blue-light text-content-action',
  neutral: 'bg-bg-tertiary text-content-tertiary',
  success: 'bg-bg-green-light text-content-success',
  danger: 'bg-bg-red-light text-content-danger',
};

type Tone = keyof typeof tones;

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
};

export function Badge({ tone = 'neutral', className = '', children, ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-1 text-xs font-semibold ${radii.pill} ${tones[tone]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
